import { Platform } from 'react-native';

export const themeColor = '#000000';
export const lightThemeColor = '#f2f7f7';

export function getTheme() {
  const disabledColor = '#909090';

  return {
    // arrows
    arrowColor: '#000000',
    arrowStyle: { padding: 0 },
    // knob
    // expandableKnobColor: themeColor,

    // month
    monthTextColor: '#000000',
    textMonthFontSize: 16,
    textMonthFontFamily: 'HelveticaNeue',
    textMonthFontWeight: 'bold' as const,
    // day names
    textSectionTitleColor: '#000000',
    textDayHeaderFontSize: 12,
    textDayHeaderFontFamily: 'HelveticaNeue',
    textDayHeaderFontWeight: 'normal' as const,
    // dates
    dayTextColor: '#a0a0a0',
    todayTextColor: '#000000',
    textDayFontSize: 18,
    textDayFontFamily: 'HelveticaNeue',
    textDayFontWeight: '500' as const,
    textDayStyle: { marginTop: Platform.OS === 'android' ? 2 : 4 },
    // selected date
    selectedDayBackgroundColor: '#FF9500',
    selectedDayTextColor: '#000000',
    selectedDayBorderColor: '#FF9500',
    selectedDayBorderWidth: 2,
    selectedDayBorderRadius: 20,
    // disabled date
    textDisabledColor: disabledColor,
    // dot (marked date)
    dotColor: "#FF9500",
    selectedDotColor: '#000000',
    disabledDotColor: disabledColor,
    dotStyle: {
      marginBottom: -1,
      width: 5,
      height: 5,
      borderRadius: 4
    }
  };
}